import React from 'react';
import LookerReport from './LookerReport';

const FlightDetailsAnalytics = () => {
  return <LookerReport source="flight_details" title="Flight Details Analytics" />;
};

export default FlightDetailsAnalytics;